module.exports = __webpack_public_path__ + "img/深耕群发朋友圈.9bd522e5.svg";